import { Injectable, InjectionToken } from '@angular/core'
import { CmsComponent, Converter } from '@spartacus/core'
import { ConvertedComponentData, Image, TextInput } from '../../types'
import { CmsConverterService, defaultTextInput } from '../../../services/cms-converter/cms-converter.service'

@Injectable({ providedIn: 'root' })
export class HeaderImageBackgroundConverter extends CmsConverterService<HeaderImageBackgroundData> {
  convertData (source: CmsComponent) {
    const formData = source?.otherProperties?.formData ?? {}
    const title = formData.st_header_image_normal_title_text?.value
    const image = formData.st_header_image_background_reference ?? {}
    const altText = formData.st_header_image_background_alternative_text?.value || image.value?.description || ''
    const lazyLoad = formData.st_lazy_load_image?.value
    return {
      textBig: formData.st_header_image_background_text_big ?? defaultTextInput,
      textSmall: formData.st_header_image_background_text_small ?? defaultTextInput,
      image: CmsConverterService.mapImage(image, lazyLoad, altText, title),
    }
  }
}

export const HEADER_IMAGE_BACKGROUND_CONVERTER_TOKEN =
  new InjectionToken<Converter<CmsComponent, HeaderImageBackgroundData>>('HeaderImageBackgroundConverter')

export interface HeaderImageBackgroundData extends ConvertedComponentData {
  textBig: TextInput;
  textSmall: TextInput;
  image: Image;
}
